import type { Service } from '../types/shop';

export const featuredService = {
  title: 'Collision repair',
  description:
    "Whether it's a parking-lot scrape or a major accident, we restore your vehicle's structure, safety systems, and finish to factory specification.",
  inclusions: [
    'OEM and certified parts',
    'Structural and frame measurement',
    'Direct insurance billing',
    'Loaner and rental coordination',
  ],
};

export const services: Service[] = [
  {
    title: 'Paint & refinishing',
    description:
      'Axalta-certified refinishing, from spot blends to full resprays, cured in a heated downdraft booth.',
  },
  {
    title: 'Computerized paint color match',
    description:
      'A spectrophotometer reads your exact paint, including fade and weathering, so new panels match the rest of your car.',
  },
  {
    title: 'Paintless dent repair',
    description:
      'Door dings and small dents pushed out from behind, keeping your original factory paint intact.',
  },
  {
    title: 'Hail damage',
    description:
      "Full hail assessments and PDR for Montana's summer storms. We handle the insurance paperwork.",
  },
  {
    title: 'Frame & unibody straightening',
    description:
      'Computerized measuring brings your frame back to manufacturer spec, documented to the millimeter.',
  },
  {
    title: 'Bumper & plastic repair',
    description: 'Cracks, scuffs, and broken tabs repaired or replaced, then refinished to match.',
  },
  {
    title: 'Glass replacement',
    description: 'Windshields, door glass, and back glass replaced and sealed properly.',
  },
  {
    title: 'Temporary repairs',
    description:
      "Waiting on parts or an insurance decision? We'll secure loose panels and cover broken glass so you can keep driving safely.",
  },
];

export const serviceOptions = [
  'Collision repair',
  'Paint & refinishing',
  'Computerized paint color match',
  'Paintless dent repair',
  'Hail damage',
  'Frame & unibody straightening',
  'Bumper & plastic repair',
  'Glass replacement',
  'Temporary repairs',
  "Not sure — I'll describe it",
];
